export default __webpack_public_path__ + "static/media/default-avatar.701be91a.png";